/**
 * JavaScript for Hero Video
 */

class HeroVideo {
  constructor($element) {
    this.$element = $element;
    this.$iframe = $element.find('.gg-hero-video__video');
    this.$btnPlayPause = $element.find('.gg-hero-video__ctrl--playpause');
    this.$btnMute = $element.find('.gg-hero-video__ctrl--mute');
    this.isPlaying = true;
    this.isMuted = true;
    this.init();
  }

  init() {
    if (!this.$iframe.length) {
      return;
    }

    this.$iframe.on('load', () => this.handleVideoLoad());

    this.handleLayoutBgImage();

    if (this.$btnPlayPause.length || this.$btnMute.length) {
      this.$btnPlayPause.on('click', () => this.togglePlayPause());
      this.$btnMute.on('click', () => this.toggleMute());
    }

    // Sync UI with initial state
    this.syncUI();
  }

  // Send postMessage directly to Vimeo iframe — no SDK needed
  postToPlayer(method, value) {
    const win = this.$iframe[0]?.contentWindow;
    if (!win) return;
    const msg = { method };
    if (value !== undefined) msg.value = value;
    win.postMessage(JSON.stringify(msg), 'https://player.vimeo.com');
  }

  togglePlayPause() {
    if (this.isPlaying) {
      this.postToPlayer('pause');
      this.isPlaying = false;
    } else {
      this.postToPlayer('play');
      this.isPlaying = true;
    }
    this.syncUI();
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    // setVolume 0/1 because Vimeo postMessage doesn't have a setMuted method
    this.postToPlayer('setVolume', this.isMuted ? 0 : 1);
    this.syncUI();
  }

  syncUI() {
    this.$btnPlayPause.attr({
      'data-state': this.isPlaying ? 'playing' : 'paused',
      'aria-label': this.isPlaying ? 'Pause video' : 'Play video',
    });
    this.$btnMute.attr({
      'data-state': this.isMuted ? 'muted' : 'unmuted',
      'aria-label': this.isMuted ? 'Unmute video' : 'Mute video',
    });
  }

  handleVideoLoad() {
    this.$element.addClass('video-loaded');
  }

  handleLayoutBgImage() {
    if (this.$element.next().hasClass('mod-brand-statement-banner')) {
      const nextElement = this.$element.next();
      const floatingBg = nextElement.find('.mod-brand-statement-banner__floating-background');

      if (floatingBg.length) {
        this.$element.prepend(floatingBg);
      }

      this.$element.append(nextElement);

      if (nextElement.attr('data-floating-effect') === 'true') {
        const picture = this.$element.find('picture');
        if (picture.length) {
          picture.remove();
        }
      }
    }
  }
}

$(document).ready(() => {
  $('.gg-hero-video').each((_index, element) => {
    new HeroVideo($(element));
  });
});
